const accessRoute = {
  LANDING_PAGE: {
    path: "/",
  },
};

export default accessRoute;
